import classNames from "classnames/bind";
import React from "react";

import { Button, Drawer, Hairline, Input } from "@components";

import { BoxTitles } from "@boxes/BoxTitles";
import { ForEach } from "@components/control-statements";

import { FlowAPI } from "@providers/FlowAPI";
import styles from "@styles/forms-flow/filtered-audience.module.scss";

const css = classNames.bind(styles);

export class CreateAudienceDrawer extends React.Component {
  state = {
    loading: false,
    name: null,
    boxes: [],
    links: [],
  };

  refreshState() {
    const { audience } = this.props;
    this.setState({
      boxes: audience?.boxes || [],
      links: audience?.links || [],
    });
  }

  async setStateAsync(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  componentDidMount() {
    this.refreshState();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.refreshState();
    }
  }

  async onSave() {
    const { name, boxes, links } = this.state;
    const { onClose } = this.props;

    await this.setStateAsync({ loading: true });
    const response = await FlowAPI.postAudience(name, boxes, links);
    await this.setStateAsync({ loading: false });

    if (response.getErrors([]).length > 0) {
      alert({
        text: response.getErrors(["Ocorreu um erro ao pausar"])[0],
        buttonText: "Voltar",
      });
      return;
    }

    await this.setStateAsync({ name: false, boxes: [], links: [] });
    onClose && onClose();
  }

  onDeleteBox(box) {}

  render() {
    const { visible, onClose } = this.props;
    const { name, boxes, loading } = this.state;

    return (
      <Drawer
        visible={visible}
        title={"Salvar público"}
        onClose={() => !loading && onClose()}
        footer={
          <Button
            className={"w-100"}
            text={"Salvar público"}
            disabled={!name || loading}
            loading={loading}
            onClick={() => this.onSave()}
          />
        }
      >
        <p className={styles.label}>Dê um nome ao seu público</p>
        <Input
          label={"Nome do público"}
          value={name}
          design="two"
          className="mt-15"
          onChange={(text) => this.setState({ name: text.target.value })}
        />
        <Hairline className="mt-30 mb-30" />
        <p className={styles.label}>Gerencie os filtros e condicionais</p>
        <div className={styles.climateVariant}>
          <div className={styles.content}>
            <div
              className={styles.options}
              style={{ gridTemplateColumns: "repeat(1, 1fr)" }}
            >
              <ForEach
                items={boxes}
                render={(box) => {
                  return (
                    <div className={`${styles.option}`}>
                      <div className="w-100 d-flex justify-between align-center">
                        <div className="flex">
                          <p>{BoxTitles[box?.type]}</p>
                        </div>
                        <div>
                          <i
                            className="fal fa-xmark mb-0"
                            onClick={() => this.onDeleteBox(box)}
                          />
                        </div>
                      </div>
                    </div>
                  );
                }}
              />
            </div>
          </div>
        </div>
      </Drawer>
    );
  }
}
